import React,{ createContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { COST_ALLOCATION_TOGGLE_BUTTON_LABELS } from './costAllocationHelpers.js';
import { INITIAL_ALLOC_FILE_STATE } from './UploadProcess/UploadDialog/uploadDialogHelpers.js';
import { SPLIT, PERSONNEL } from '../../static/keyWords.js';
import { getMoneyObj } from '../reusable/MoneyJsHelpers.js';
import { handleDataChangeWrapper } from './costAllocationCalculations.js';
import { REDUCER_ACTION_TYPES } from '../../store/Reducer.js';

export const costAllocContextInitState = {
  selectedItemAllocations: null,
  currentTabValue: PERSONNEL,
  selectedItems: [],
  selectedItemsArray: null,
  combinedTotalCost: 0,
  allocationMode: COST_ALLOCATION_TOGGLE_BUTTON_LABELS[0],
};

export const CostAllocationContext = createContext(costAllocContextInitState);

const CostAllocationContextProvider = ({children}) => {

  const [isOpenUploadDialog, setIsOpenUploadDialog] = useState(false);
  const [view, setView] = useState(SPLIT); //[ Split, Table, Upload]
  const [itemsForBar, setItemsForBar] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [originalSelectedItems, setOriginalSelectedItems] = useState([]);
  const [selectedItemAllocations, setSelectedItemAllocations] = useState([]);
  const [originalSelectedItemAllocations, setOriginalSelectedItemAllocations] = useState(null);
  const [combinedTotalCostOfItems, setCombinedTotalCostOfItems] = useState(0);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [totalAllocationCount, setTotalAllocationCount] = useState(0);
  const [previewPercent, setPreviewPercent] = useState(0);
  const [barClickedForAllocationPanel, setBarClickedForAllocationPanel] =
    useState();
  const [resized, setResized] = useState(1);
  const [allocationMode, setAllocationMode] = useState(COST_ALLOCATION_TOGGLE_BUTTON_LABELS[0]);
  const [disableSelectAll, setDisableSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentTabValue, setCurrentTabValue] = useState();
  const [totalProgramCost, setTotalProgramCost] = useState(getMoneyObj(0));
  const [triggerUpdateAllocations, setTriggerUpdateAllocations] = useState(false);
  const [triggerUploadAllocations, setTriggerUploadAllocations] = useState(false);
  const [costingRecommendation, setCostingRecommendation] = useState();
  const [allocFile, setAllocFile] = useState(INITIAL_ALLOC_FILE_STATE);
  const [mistakes, setMistakes] = useState([0, 0]);
  const [actionRows, setActionRows] = useState(0);
  const [selectedAdditionalCCs, setSelectedAdditionalCCs] = useState([]);
  const [positiveOnly, setPositiveOnly] = useState(true);
  const [missingUploadColumns, setMissingUploadColumns] = useState(false);
  const [newUpload, setNewUpload] = useState(false);
  // which fields are expanded by id -> {id: childrenCount}
  let expandedFieldsRef = useRef({});
  // how much each bar is translated when another one is expanded
  let translatedFieldsRef = useRef({});


  //changes which needs to happen on view change
  useEffect(() => {
    if (view === SPLIT) {
      setAllocationMode(COST_ALLOCATION_TOGGLE_BUTTON_LABELS[0]);
      setCurrentTabValue(PERSONNEL);
    }
  }, [view]);

  //changes which needs to happen on items for bar change 
  //item total cost mixed-sign check
  useEffect(() => {
    if (itemsForBar && itemsForBar.length) {
      setDisableSelectAll(itemsForBar.some(item=>item.total_cost > 0) && itemsForBar.some(item=>item.total_cost < 0));
    }
  }, [itemsForBar]);

  //changes needs to happen when user selects items
  useEffect(() => {
    setCombinedTotalCostOfItems(selectedItems.reduce(
      (sum, item) => sum.add(getMoneyObj(item.total_cost)),
      getMoneyObj(0)
    ));
  }, [selectedItems]);

  const handleDataChange = (params, dispatch) => {
    handleDataChangeWrapper(
      params, 
      allocationMode, 
      selectedItemAllocations, 
      selectedItems, 
      positiveOnly,
      setSelectedItemAllocations,
      setSelectedItems,
      setPreviewPercent,
      setTotalProgramCost, 
      setCombinedTotalCostOfItems,
      setTotalAllocationCount
    );
    dispatch({ type: REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG, payload: true });
  };

  const reset = () => {
    setSelectedItems([]);
    setSelectedItemAllocations(null);
    setCurrentTabValue(PERSONNEL);
    setCurrentPage(0);
    setAllocFile(INITIAL_ALLOC_FILE_STATE);
    setMistakes([0, 0]);
    setActionRows(0);
    setAllocationMode(COST_ALLOCATION_TOGGLE_BUTTON_LABELS[0]);
    setPreviewPercent(0);
    setTotalAllocationCount(0);
    setSelectedAdditionalCCs([]);
    setPositiveOnly(true);
    setMissingUploadColumns(false);
  };
  
  return (
    <CostAllocationContext.Provider value={{
      selectedItems,
      setSelectedItems,
      originalSelectedItems,
      setOriginalSelectedItems,
      selectedItemAllocations,
      setSelectedItemAllocations,
      currentTabValue,
      setCurrentTabValue,
      allocationMode,
      setAllocationMode,
      allocFile,
      setAllocFile,
      currentPage,
      setCurrentPage,
      view,
      setView,
      triggerUpdateAllocations,
      setTriggerUpdateAllocations,
      triggerUploadAllocations,
      setTriggerUploadAllocations,
      costingRecommendation,
      setCostingRecommendation,
      mistakes,
      setMistakes,
      actionRows,
      setActionRows,
      reset,
      resized,
      setResized,
      barClickedForAllocationPanel,
      setBarClickedForAllocationPanel,
      originalSelectedItemAllocations,
      setOriginalSelectedItemAllocations,
      totalItemsCount,
      setTotalItemsCount,
      previewPercent,
      setPreviewPercent,
      handleDataChange,
      itemsForBar,
      setItemsForBar,
      totalAllocationCount,
      setTotalAllocationCount,
      disableSelectAll,
      combinedTotalCostOfItems,
      totalProgramCost,
      selectedAdditionalCCs,
      setSelectedAdditionalCCs,
      positiveOnly,
      setPositiveOnly,
      setTotalProgramCost,
      setCombinedTotalCostOfItems,
      missingUploadColumns,
      setMissingUploadColumns,
      newUpload,
      setNewUpload,
      isOpenUploadDialog,
      setIsOpenUploadDialog,
      expandedFieldsRef,
      translatedFieldsRef,
    }}
    >
      {children}
    </CostAllocationContext.Provider>
  );
};

CostAllocationContextProvider.propTypes = {
  children: PropTypes.node,
};

export default CostAllocationContextProvider;
